import React from 'react'
import ReactDOM from 'react-dom'
import { applyMiddleware, compose, createStore } from 'redux'
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'
import { createLogger } from 'redux-logger'
import { createBrowserHistory } from 'history'
import { routerMiddleware, connectRouter } from 'connected-react-router'
import rootReducer from './reducers'

import { LocaleProvider } from 'antd'
import fa_IR from 'antd/lib/locale-provider/fa_IR'
import App from './containers/App'
// import 'moment/locale/fa';
import './theme.less';
import persianJs from './../node_modules/persianjs/persian';

const history = createBrowserHistory()

const middleware = [ thunk ]
if (process.env.NODE_ENV !== 'production') {
    middleware.push(createLogger());
}


// change all persian numbers to en
document.addEventListener('change', function (event) {
  let all_inputs = document.querySelectorAll('input[type="text"]');
  all_inputs.forEach(function(element) {
    if(!element.value) {
      return;
    }
    element.setAttribute('value', persianJs(element.value).toEnglishNumber()._str);
    element.value = persianJs(element.value).toEnglishNumber()._str;
  });
  let all_text = document.querySelectorAll('textarea');
  all_text.forEach(function(element) {
    if(!element.value) {
      return;
    }
    element.value = persianJs(element.value).toEnglishNumber()._str;
  });
}, false);


const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const store = createStore(
  connectRouter(history)(rootReducer),
  composeEnhancer(
    applyMiddleware(
      routerMiddleware(history),
      ...middleware
    ),
  ),
)

const render = () => {
    ReactDOM.render(
        <Provider store={store}>
          <LocaleProvider locale={fa_IR}><App history={history} /></LocaleProvider>
        </Provider>,
        document.getElementById('root')
    )
}

render()


// WEBPACK FOOTER //
// ./src/index.js